import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { BorderGradient, Actions, Belt, Helper } from 'Components';
import './TemplatesDesktopSearchHeader.css';

const TemplatesDesktopSearchHeader = ({
  onPageSizeChange,
  pageSize,
  showNoInformationFound,
  onSearchDownload,
}) => (
  <div className="templates-desktop-search-header">
    <div className="templates-desktop-search-header__controls">
      <Belt>
        <Helper text={i18n.t('tutorials:common.ExportToExcel')}>
          <Actions.ExportToExcel
            onClick={onSearchDownload}
          />
        </Helper>
        <Helper text={i18n.t('tutorials:search.4')} placement="bottom-left">
          <Actions.ClearSearch to="/templates" />
        </Helper>
      </Belt>
    </div>
    <BorderGradient />
    {!showNoInformationFound &&
    <div className="templates-desktop-search-header__results-per-page">
      <Actions.ResultsPerPage onChange={onPageSizeChange} value={pageSize} />
    </div>}
  </div>
);

TemplatesDesktopSearchHeader.propTypes = {
  onPageSizeChange: PropTypes.func,
  showNoInformationFound: PropTypes.bool,
  pageSize: PropTypes.number,
  onSearchDownload: PropTypes.func,
};
export default TemplatesDesktopSearchHeader;



// WEBPACK FOOTER //
// ./src/containers/Templates/TemplatesDesktop/TemplatesDesktopSearchHeader/TemplatesDesktopSearchHeader.jsx